// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"4093b999","103":"2e7e9ebb"}[chunkId] + ".chunk.css";
};